module.exports = __webpack_public_path__ + "c76c36cdbd03aeb20bd44c68099862dc.svg";